import type { MessageSchema, NumberSchema } from '@/i18n/i18nOptions';
import { createI18n } from 'vue-i18n';
import { i18nOptions } from '@/i18n/i18nOptions';
import type { Locale } from '@/i18n/models';

// TODO (S.Panfilov) "any", for some reason "i18nOptions" doesnt match the type
export const i18n = createI18n<{ readonly messages: readonly [MessageSchema]; readonly number: NumberSchema }, Locale.NL | Locale.EN>(i18nOptions as any);
